import { Injectable, NgModule } from '@angular/core';
import { NotificationService } from '../util/notification.service';
import { HttpClient } from '../util/http.service';
import { Observable } from 'rxjs';
import { SiteBrowserState } from '../util/site-browser.state';
import { FileSearchService } from './file-search.service';
/**
 * Can be used for CRUD operations on dotCMS FileAssets. Not all CRUD operations are currently implemented
 */
var FileService = (function () {
    function FileService(httpClient, siteBrowserState, notificationService) {
        this.httpClient = httpClient;
        this.siteBrowserState = siteBrowserState;
        this.notificationService = notificationService;
    }
    /**
     * ******  NOT IMPLEMENTED YET *******
     * Will save an array of local files and upload them to dotCMS. The dotCMS file Object will be built by the upload method
     * which means it will not set a Structure/Content Type and will not set the Identifier if the file already exists
     * in dotCMS.  dotCMS will create a new version if the file already exists on the uploaded path or create a new one.
     * The Structure/Content Type is set accordig to the default type on the uploaded dotCMS Folder
     * @param fileList array of file objects to be POSTED to dotCMS
     */
    // TODO : NOT IMPLEMENTED YET
    FileService.prototype.saveFiles = function (fileList) {
    };
    /**
     * Will upload a local file to dotCMS
     * @param file file from teh file System to upload
     * @param path dotCMS Path to upload file to
     */
    FileService.prototype.uploadFile = function (file, path, fileContentTypeID) {
        var data = {
            fileName: file.name,
            hostFolder: this.siteBrowserState.getSelectedSite().hostname + ':' + path,
            stInode: fileContentTypeID,
            title: file.name,
            type: file.type
        };
        this.httpClient.filePut('/api/content/save/1', file, data).subscribe();
    };
    /**
     * Will post to dotCMS an array of the FolderNames to create. If the folder already exists nothing will happen.
     * Even if there are failure it will create the Folders it is able to and log any error on folders it could not create
     * @param directories list of local file System directories to create on dotCMS
     */
    // TODO : SHOULD MOVE TO FolderServices
    FileService.prototype.uploadDirectories = function (directories) {
    };
    FileService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        if (errMsg) {
            console.log(errMsg);
            this.notificationService.displayErrorMessage('There was an error uploading file; please try again : ' + errMsg);
            return Observable.throw(errMsg);
        }
    };
    return FileService;
}());
export { FileService };
FileService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
FileService.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: SiteBrowserState, },
    { type: NotificationService, },
]; };
var DotFileModule = (function () {
    function DotFileModule() {
    }
    return DotFileModule;
}());
export { DotFileModule };
DotFileModule.decorators = [
    { type: NgModule, args: [{
                providers: [HttpClient, NotificationService, FileService, FileSearchService]
            },] },
];
/** @nocollapse */
DotFileModule.ctorParameters = function () { return []; };
//# sourceMappingURL=file.services.js.map